import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "area_title" }
const _hoisted_2 = { class: "area_button" }
const _hoisted_3 = { class: "area_body" }
const _hoisted_4 = { class: "area_section noPrint" }
const _hoisted_5 = { class: "area_tab" }
const _hoisted_6 = { class: "area_search" }
const _hoisted_7 = { class: "datepicker" }
const _hoisted_8 = { class: "datepicker" }
const _hoisted_9 = { class: "datepicker" }
const _hoisted_10 = { class: "datepicker" }
const _hoisted_11 = { class: "datepicker" }
const _hoisted_12 = { class: "datepicker" }
const _hoisted_13 = { class: "radio_wrap" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = ["checked"]
const _hoisted_16 = ["checked"]
const _hoisted_17 = { class: "area_button" }
const _hoisted_18 = {
  class: "print_table onlyPrint",
  style: {"text-align":"center","font-size":"1rem"}
}
const _hoisted_19 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Counsel = _resolveComponent("Counsel")!
  const _component_Client = _resolveComponent("Client")!
  const _component_Year = _resolveComponent("Year")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", {
      class: _normalizeClass(["container statistics", { pdfMode: $setup.isPdfMode }]),
      id: "pdfArea"
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[24] || (_cache[24] = _createElementVNode("p", null, "통계", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.downloadPdf && $setup.downloadPdf(...args)))
            }, _cache[22] || (_cache[22] = [
              _createElementVNode("img", { src: "img/print.png" }, null, -1),
              _createElementVNode("span", null, "PDF 출력", -1)
            ])),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.downloadFile && $setup.downloadFile(...args)))
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("img", { src: "img/excel.png" }, null, -1),
              _createElementVNode("span", null, "Excel 다운", -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.category === '' }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
                                $setup.state.category = '';
                                $setup.router.push({ name: 'statisticsCommon', query: { category: $setup.state.category } });
                                $setup.fnGetData();
                            })
              }, _cache[25] || (_cache[25] = [
                _createElementVNode("span", null, "전체", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.category === '상담팀' }),
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
                                $setup.state.category = '상담팀';
                                $setup.router.push({ name: 'statisticsCommon', query: { category: $setup.state.category } });
                                $setup.fnGetData();
                            })
              }, _cache[26] || (_cache[26] = [
                _createElementVNode("span", null, "상담팀", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.category === '청소년' }),
                onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                $setup.state.category = '청소년';
                                $setup.router.push({ name: 'statisticsCommon', query: { category: $setup.state.category } });
                                $setup.fnGetData();
                            })
              }, _cache[27] || (_cache[27] = [
                _createElementVNode("span", null, "청소년팀", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.category === '현장팀' }),
                onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                $setup.state.category = '현장팀';
                                $setup.router.push({ name: 'statisticsCommon', query: { category: $setup.state.category } });
                                $setup.fnGetData();
                            })
              }, _cache[28] || (_cache[28] = [
                _createElementVNode("span", null, "현장팀", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.category === '상담팀,청소년' }),
                onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                $setup.state.category = '상담팀,청소년';
                                $setup.router.push({ name: 'statisticsCommon', query: { category: $setup.state.category } });
                                $setup.fnGetData();
                            })
              }, _cache[29] || (_cache[29] = [
                _createElementVNode("span", null, "상담팀+청소년팀", -1)
              ]), 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[31] || (_cache[31] = _createElementVNode("label", null, "작성일", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "startDate",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.startDate) = $event)),
                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.changeStartDate && $setup.changeStartDate(...args)))
                    }, null, 544), [
                      [_vModelText, $setup.state.startDate]
                    ])
                  ]),
                  _cache[30] || (_cache[30] = _createElementVNode("span", null, "~", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "endDate",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.endDate) = $event)),
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.changeEndDate && $setup.changeEndDate(...args)))
                    }, null, 544), [
                      [_vModelText, $setup.state.endDate]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {
                                        $setup.setDateToToday();
                                        $setup.fnGetData();
                                    })
                  }, " 오늘날짜 ")
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[34] || (_cache[34] = _createElementVNode("label", null, "작성일2", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "startDate",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.startDate2) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.state.startDate2]
                    ])
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("span", null, "~", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "endDate",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.endDate2) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.state.endDate2]
                    ])
                  ]),
                  _createVNode(_component_router_link, {
                    to: {
                                        name: 'statisticsCommon',
                                        query: { category: $setup.state.category, startDate: $setup.state.startDate2, endDate: $setup.state.endDate2 },
                                    },
                    target: "_blank",
                    style: {"border-radius":"5px","border":"1px solid #d9d9d9","padding":"2px 10px","background-color":"white"}
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode(" 새창 비교 검색 ", -1)
                    ])),
                    _: 1,
                    __: [32]
                  }, 8, ["to"])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[37] || (_cache[37] = _createElementVNode("label", null, "작성일3", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "startDate",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.startDate3) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.state.startDate3]
                    ])
                  ]),
                  _cache[36] || (_cache[36] = _createElementVNode("span", null, "~", -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "endDate",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.state.endDate3) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.state.endDate3]
                    ])
                  ]),
                  _createVNode(_component_router_link, {
                    to: {
                                        name: 'statisticsCommon',
                                        query: { category: $setup.state.category, startDate: $setup.state.startDate3, endDate: $setup.state.endDate3 },
                                    },
                    target: "_blank",
                    style: {"border-radius":"5px","border":"1px solid #d9d9d9","padding":"2px 10px","background-color":"white"}
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode(" 새창 비교 검색 ", -1)
                    ])),
                    _: 1,
                    __: [35]
                  }, 8, ["to"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", null, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "state",
                        checked: $setup.state.type === 1,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                                $setup.state.type = 1;
                                                $setup.fnGetData();
                                            })
                      }, null, 8, _hoisted_14),
                      _cache[38] || (_cache[38] = _createElementVNode("em", null, null, -1)),
                      _cache[39] || (_cache[39] = _createElementVNode("span", null, "상담기록 기준 통계", -1))
                    ]),
                    _createElementVNode("label", null, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "state",
                        checked: $setup.state.type === 2,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => {
                                                $setup.state.type = 2;
                                                $setup.fnGetData();
                                            })
                      }, null, 8, _hoisted_15),
                      _cache[40] || (_cache[40] = _createElementVNode("em", null, null, -1)),
                      _cache[41] || (_cache[41] = _createElementVNode("span", null, "기초기록 기준 통계", -1))
                    ]),
                    _createElementVNode("label", null, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "state",
                        checked: $setup.state.type === 3,
                        onClick: _cache[18] || (_cache[18] = ($event: any) => {
                                                $setup.state.type = 3;
                                                $setup.fnGetData();
                                            })
                      }, null, 8, _hoisted_16),
                      _cache[42] || (_cache[42] = _createElementVNode("em", null, null, -1)),
                      _cache[43] || (_cache[43] = _createElementVNode("span", null, "연도별 추이", -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => {
                                    $setup.reset();
                                    $setup.fnGetData();
                                })
                }, " 초기화 "),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.fnGetData()))
                }, "검색")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, "다시함께상담센터 [" + _toDisplayString($setup.state.category === "" ? "전체" : $setup.state.category) + "]", 1),
            _cache[44] || (_cache[44] = _createElementVNode("p", null, "tel 02) 814-3660 / fax 02) 814-8556 / E-mail: dasi_seoul@naver.com", -1)),
            _createElementVNode("p", null, _toDisplayString($setup.CommonUtils.convertDateToYMDForKor($setup.state.startDate)) + " ~ " + _toDisplayString($setup.CommonUtils.convertDateToYMDForKor($setup.state.endDate)) + " " + _toDisplayString($setup.state.type == 1 ? "상담기록기준" : $setup.state.type == 2 ? "기초기록기준" : "연도별추이"), 1)
          ]),
          ($setup.state.isLoading)
            ? (_openBlock(), _createBlock(_component_Spinner, {
                key: 0,
                spinnerSize: 70,
                thickness: 10
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($setup.state.type === 1 && $setup.state.data != null && $setup.state.data.length > 0)
                  ? (_openBlock(), _createBlock(_component_Counsel, {
                      key: 0,
                      data: $setup.state.data,
                      sYear: Number($setup.state.startDate.substring(0, 4))
                    }, null, 8, ["data", "sYear"]))
                  : _createCommentVNode("", true),
                ($setup.state.type === 2 && $setup.state.data != null && $setup.state.data.length > 0)
                  ? (_openBlock(), _createBlock(_component_Client, {
                      key: 1,
                      data: $setup.state.data,
                      sYear: Number($setup.state.startDate.substring(0, 4))
                    }, null, 8, ["data", "sYear"]))
                  : _createCommentVNode("", true),
                ($setup.state.type === 3 && $setup.state.data != null && $setup.state.data.length > 0)
                  ? (_openBlock(), _createBlock(_component_Year, {
                      key: 2,
                      data: $setup.state.data,
                      startYear: Number($setup.state.startDate.substring(0, 4)),
                      endYear: Number($setup.state.endDate.substring(0, 4))
                    }, null, 8, ["data", "startYear", "endYear"]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ], 2),
    ($setup.state.isGlobalLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "is-full-page": true
        }))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[21] || (_cache[21] = ($event: any) => ($setup.state.isShowModal = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}